import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { HmacSHA256 } from 'crypto-js';
import { AuthService } from '../services/auth.service';
import { UserUtil } from '../utils/user.utils';

@Injectable({
  providedIn: 'root',
})
export class IntercomGuard implements CanActivate {
  private intercom: any;

  constructor(
    private router: Router,
    private readonly authService: AuthService,
    private readonly userUtil: UserUtil
  ) {
    this.intercom = (<any>window).Intercom;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.isAuthenticated()) {
      this.udateIntercom();
    } else {
      (<any>window).Intercom('shutdown');
    }
    return true;
  }

  private isMobile() {
    const screenWidth = window.innerWidth;

    return screenWidth < 768;
  }

  private udateIntercom(): void {
    const user = this.userUtil.getUser();
    if (user && user.integration && user.integration.unimestre) {
      const cdPessoa = user.integration.unimestre.cdPessoa;
      this.intercom('reattach_activator');
      this.intercom('update', {
        api_base: 'https://api-iam.intercom.io',
        app_id: 'ttlqhvzf',
        alignment: this.isMobile() ? 'left' : 'right',
        user_id: cdPessoa,
        email: user.email,
        name: user.firstName,
        agenda: 'SIM',
        user_hash: this.createHash(cdPessoa),
      });
      this.intercom('update', {
        last_request_at: Math.floor(new Date().getTime() / 1000),
      });
    } else {
      (<any>window).Intercom('shutdown');
    }
  }

  private createHash(idUser: string) {
    var hmac = HmacSHA256(idUser, 'v0EutTw9mID_jnSOzSu3iMbCmVTxNCjfLDbgRPx-');
    return hmac.toString();
  }
}
